import { IStoreState } from "modules/types";

export const getSpeakers = (state: IStoreState) => state.speaker.speakers;